import React from 'react';

/** Small semantic badge. Subtle tint + readable text — never a saturated pill. */
const Badge = ({ children, variant = 'neutral', dot = false, className = '', ...props }) => (
    <span className={`badge badge-${variant} ${className}`} {...props}>
        {dot && (
            <span
                aria-hidden="true"
                className="inline-block w-1.5 h-1.5 rounded-full bg-current opacity-70"
            />
        )}
        {children}
    </span>
);

const humanize = (value) =>
    String(value || '')
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase());

const slug = (value) => String(value || '').toLowerCase().trim().replace(/\s+/g, '_');

/* Domain wording that title-casing alone would get wrong. */
const LABELS = {
    todo: 'To do',
    in_progress: 'In progress',
    on_hold: 'On hold',
    aob: 'AOB',
    face_to_face: 'Face to face',
};

/**
 * Status badge driven by the domain value itself (todo, in_progress, on_hold…).
 * Colour mapping lives in index.css so every surface agrees.
 */
export const StatusBadge = ({ status, label, className = '' }) => {
    if (!status) return <span className="text-muted">—</span>;
    return (
        <span className={`badge status-${slug(status)} ${className}`}>
            {label || LABELS[slug(status)] || humanize(status)}
        </span>
    );
};

/** Priority badge — low / medium / high / critical. */
export const PriorityBadge = ({ priority, className = '' }) => {
    if (!priority) return <span className="text-muted">—</span>;
    return (
        <span className={`badge priority-${slug(priority)} ${className}`}>
            {humanize(priority)}
        </span>
    );
};

export { humanize };
export default Badge;
